import { Chip } from "@gigpro/ui/Chip";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@gigpro/ui/Collapsible";
import { ChevronDown } from "@gigpro/ui/Icons";
import { Skeleton } from "@gigpro/ui/Skeleton";
import React from "react";
import { times } from "remeda";

type PROfileSkillsProps = { data: Record<string, Array<string>> };

export const PROfileSkills: React.FC<PROfileSkillsProps> = ({ data }) => {
  const skillsByPosition = Object.entries(data);
  return (
    <Collapsible defaultOpen>
      <CollapsibleTrigger className="group flex w-full items-center">
        <h2 className="profile-title flex justify-between text-large font-semibold @sm/profile:text-extraLarge">
          Skills
        </h2>
        <ChevronDown className="ml-auto size-4 transition-transform group-data-[state=open]:rotate-180" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        {skillsByPosition.length ? (
          skillsByPosition.map(([position, skills]) => (
            <React.Fragment key={position}>
              <h3 className="my-2 text-normal font-semibold @sm/profile:text-large">Related to {position}</h3>
              <div className="flex flex-wrap gap-2">
                {skills.map((skill) => (
                  <Chip key={skill}>{skill}</Chip>
                ))}
              </div>
            </React.Fragment>
          ))
        ) : (
          <p className="mt-2 text-medium-gray">This pro has not selected any skills.</p>
        )}
      </CollapsibleContent>
    </Collapsible>
  );
};

export const PROfileSkillsSkeleton = () => (
  <>
    <h2 className="profile-title flex justify-between text-large font-semibold @sm/profile:text-extraLarge">Skills</h2>
    {times(2, (i) => (
      <React.Fragment key={i}>
        <Skeleton className="my-2 w-40 text-normal font-semibold @sm/profile:text-large" />
        {times(3, (index) => (
          <Skeleton key={index} variant="rounded" className="mr-2 mb-2 inline-flex h-5 w-36 align-middle" />
        ))}
      </React.Fragment>
    ))}
  </>
);
